var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPauseinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 26,
    viewBox: "0 0 22 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 1.332H2.667C1.747 1.332 1 2.078 1 2.999v20c0 .92.746 1.666 1.667 1.666H6c.92 0 1.667-.746 1.667-1.666v-20c0-.92-.747-1.667-1.667-1.667zM19.333 1.332H16c-.92 0-1.667.746-1.667 1.667v20c0 .92.746 1.666 1.667 1.666h3.333c.92 0 1.667-.746 1.667-1.666v-20c0-.92-.747-1.667-1.667-1.667z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgPauseinline;